import { Controller } from "@hotwired/stimulus"
import { loadYandexMaps } from "../lib/yandex_maps"

export default class extends Controller {
  static values = { apikey: String, lat: Number, lng: Number }
  static targets = ["container"]

  connect() {
    if (!this.apikeyValue || !this.latValue || !this.lngValue) return

    loadYandexMaps(this.apikeyValue).then(() => this.initMap())
  }

  initMap() {
    this.map = new ymaps.Map(this.containerTarget, {
      center: [this.latValue, this.lngValue],
      zoom: 15
    })

    this.map.controls.remove("searchControl")

    const marker = new ymaps.Placemark([this.latValue, this.lngValue], {}, {
      preset: "islands#redDotIcon"
    })

    this.map.geoObjects.add(marker)
  }
}
